import { AdditionalColors } from '@gc-bridge/theme/colors';
import { ArrowForward } from '@mui/icons-material';
import { Box, BoxProps, styled, Typography } from '@mui/material';

const LinkContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'uppercase',
})<BoxProps & { active: boolean; uppercase: boolean }>(
  ({ active, uppercase, theme: { palette } }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: AdditionalColors.MilkyWay,
    padding: '8px 16px',
    borderRadius: '4px',
    filter: active ? '' : 'grayscale(100%)',
    width: '100%',
    textTransform: uppercase ? 'uppercase' : 'none',
    boxSizing: 'border-box',

    '&:hover': {
      backgroundColor: active ? palette.background.default : undefined,
      cursor: active ? 'pointer' : 'default',
    },
  })
);

interface Props {
  background?: string;
  disabled?: boolean;
  label: string;
  uppercase?: boolean;
}

export function LinkLabel({ background, disabled, label, uppercase = false }: Props) {
  return (
    <LinkContainer
      active={!disabled}
      uppercase={uppercase}
      sx={{
        color: disabled ? AdditionalColors.Gray79 : 'primary.light',
        backgroundColor: background,
      }}
    >
      <Typography
        variant="subtitle1"
        fontSize="24px"
        lineHeight="40px"
        color="primary.light"
      >
        {label}
      </Typography>
      {disabled ? (
        <Typography variant="h6" fontSize="16px" letterSpacing="1px">
          coming soon
        </Typography>
      ) : (
        <ArrowForward />
      )}
    </LinkContainer>
  );
}
